import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParametroRatingClusterService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametros-rating-cluster/excel/deletar', 'excelParametroRatingClusterDeletar');
    },
    salvarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametros-rating-cluster/excel', 'excelParametroRatingCluster');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('parametros-rating-cluster/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('parametros-rating-cluster/eventGrid', {});
    }
}

export default ParametroRatingClusterService;